@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.formField {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.formFieldLabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formFieldLabelTitle {
  color: v.$palette-white;
  @include t.text(10px, 12px, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.formFieldLabelForgotPassword {
  cursor: pointer;
  color: v.$palette-white;
  @include t.text(10px, 12px, "medium");
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.formFieldInputWrapper {
  position: relative;
}

.formFieldInputPasswordButton {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  cursor: pointer;
}

.formFieldInputPasswordHidden {
  letter-spacing: 10px;
}

.formFieldInputPassword {
  padding-right: 48px !important;
}
